import unfetch from 'unfetch';
export default function getFetch() {
  return window && window.fetch || unfetch;
}


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@splitsoftware/splitio/es/services/getFetch/browser.js
// module id = 2842
// module chunks = 1